(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ep-bioactive-accordion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ep-bioactives')){
  customElements.define('ep-bioactives',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();const opts={signal:this.controller.signal};this.cards=[...this.querySelectorAll('[data-panel]')];this.selects=[...this.querySelectorAll('[data-select]')];this.dots=[...this.querySelectorAll('[data-dot]')];this.i=0;
      this.selects.forEach((b,i)=>{b.addEventListener('click',()=>{this.hoverLock=performance.now()+600;this.show(i)},opts);b.addEventListener('focus',()=>{if(b.matches(':focus-visible'))this.show(i)},opts);b.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%this.cards.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i+this.cards.length-1)%this.cards.length;if(next!==undefined){e.preventDefault();this.show(next);this.selects[next].focus()}},opts)});
      this.cards.forEach((c,i)=>c.addEventListener('pointermove',e=>{if(this.i!==i&&performance.now()>(this.hoverLock||0)&&e.pointerType==='mouse'&&(Math.abs(e.movementX)+Math.abs(e.movementY)>0)&&matchMedia('(min-width:750px) and (hover:hover)').matches)this.show(i)},opts));
      this.dots.forEach((b,i)=>b.addEventListener('click',()=>this.show(i),opts));
      this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-panel]');const i=this.cards.indexOf(card);if(i>=0)this.show(i)},opts);this.show(0);
    }
    show(i){this.i=i;this.cards.forEach((c,n)=>{const on=n===i;c.dataset.active=String(on);c.querySelector('.ep-bio__copy').hidden=!on;this.selects[n].setAttribute('aria-expanded',String(on));this.dots[n].setAttribute('aria-pressed',String(on))})}
    disconnectedCallback(){this.controller?.abort()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-blueprint-video"] && !Shopify.designMode) return;
  try {
    
if(!window.epBlueprintVideoObserver){
  window.epBlueprintVideoObserver=new IntersectionObserver(entries=>{for(const entry of entries){const v=entry.target;v.muted=true;if(entry.isIntersecting&&!document.hidden){v.play()?.catch(()=>{})}else{v.pause()}}},{threshold:.1});
}
function epObserveBlueprintVideos(root){root.querySelectorAll('.ep-blueprint-video').forEach(v=>window.epBlueprintVideoObserver.observe(v));}
epObserveBlueprintVideos(document);
document.addEventListener('shopify:section:load',e=>epObserveBlueprintVideos(e.target));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.ep-blueprint-video').forEach(v=>window.epBlueprintVideoObserver.unobserve(v)));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-iconics-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ep-iconics')){
  customElements.define('ep-iconics',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();const opts={signal:this.controller.signal};
      this.visuals=[...this.querySelectorAll('[data-visual]')];this.copies=[...this.querySelectorAll('[data-copy]')];this.nav=[...this.querySelectorAll('[data-select]')];this.toggle=this.querySelector('[data-toggle]');this.i=0;this.paused=this.dataset.autoplay!=='true';this.visible=false;this.hovered=false;this.focused=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.nav.forEach((b,i)=>b.addEventListener('click',()=>this.show(i),opts));
      this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>this.show(this.i+Number(b.dataset.step)),opts));
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.sync()},opts);
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.sync()}},opts);this.addEventListener('pointerleave',()=>{this.hovered=false;this.sync()},opts);
      this.addEventListener('focusin',()=>{this.focused=true;this.sync()},opts);this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.sync()}),opts);
      this.addEventListener('shopify:block:select',e=>{const copy=e.target.closest('[data-copy]');const i=this.copies.indexOf(copy);if(i>=0){this.paused=true;this.show(i)}},opts);
      document.addEventListener('visibilitychange',()=>this.sync(),opts);this.motion.addEventListener('change',()=>this.sync(),opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.2});this.observer.observe(this);this.show(0);
    }
    show(i){if(!this.nav.length)return;this.i=(i+this.nav.length)%this.nav.length;this.visuals.forEach((v,n)=>v.hidden=n!==this.i);this.copies.forEach((v,n)=>v.hidden=n!==this.i);this.nav.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===this.i)));this.sync()}
    sync(){clearInterval(this.timer);this.toggle.textContent=this.paused?'▶':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);this.toggle.setAttribute('aria-pressed',String(this.paused));const running=!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&!this.motion.matches&&this.nav.length>1;this.dataset.running=String(running);if(running)this.timer=setInterval(()=>this.show(this.i+1),Number(this.dataset.delay)||6000)}
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-nature-statement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ep-nature-statement')){
  customElements.define('ep-nature-statement',class extends HTMLElement{
    connectedCallback(){
      this.video=this.querySelector('video');
      if(!this.video)return;
      this.video.muted=true;
      this.controller=new AbortController();
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.1});
      this.observer.observe(this);
      document.addEventListener('visibilitychange',()=>this.sync(),{signal:this.controller.signal});
      this.motion.addEventListener('change',()=>this.sync(),{signal:this.controller.signal});
    }
    sync(){if(this.visible&&!document.hidden&&!this.motion.matches){this.video.play()?.catch(()=>{})}else{this.video.pause()}}
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.video?.pause()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-prototype-video-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ep-prototype-hero')){
  customElements.define('ep-prototype-hero',class extends HTMLElement{
    connectedCallback(){
      this.video=this.querySelector('video');
      if(!this.video)return;
      this.controller=new AbortController();
      this.header=document.querySelector('.section-header');
      if(this.header){
        this.headerResize=new ResizeObserver(()=>{const height=this.header.getBoundingClientRect().height+'px';this.header.style.setProperty('--ep-home-header-height',height);this.style.setProperty('--ep-home-header-height',height);syncHeader()});
        this.headerResize.observe(this.header);
        const syncHeader=()=>this.header.classList.toggle('ep-home-header-scrolled',this.getBoundingClientRect().bottom<=this.header.getBoundingClientRect().height);
        document.addEventListener('scroll',syncHeader,{passive:true,signal:this.controller.signal});
        syncHeader();
      }
      this.visible=false;
      this.video.muted=true;
      this.video.defaultMuted=true;
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.15});
      this.observer.observe(this);
      document.addEventListener('visibilitychange',()=>this.sync(),{signal:this.controller.signal});
    }
    sync(){if(this.visible&&!document.hidden){this.video.play()?.catch(()=>{})}else{this.video.pause()}}
    disconnectedCallback(){this.observer?.disconnect();this.headerResize?.disconnect();this.controller?.abort();this.header?.style.removeProperty('--ep-home-header-height');this.header?.classList.remove('ep-home-header-scrolled');this.video?.pause()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-review-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ep-review-carousel')){
  customElements.define('ep-review-carousel',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('.ep-reviews__track');
      this.toggle=this.querySelector('[data-toggle]');
      this.paused=this.dataset.autoplay!=='true';
      this.hovered=false;
      this.focused=false;
      this.visible=false;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>this.move(Number(button.dataset.direction)),options));
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.sync()},options);
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.sync()}},options);
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.sync()},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.sync()},options);
      this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.sync()}),options);
      document.addEventListener('visibilitychange',()=>this.sync(),options);
      this.motion.addEventListener('change',()=>this.sync(),options);
      this.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.ep-review');if(card){this.track.scrollTo({left:card.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:'auto'});this.paused=true;this.sync()}},options);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.25});
      this.observer.observe(this);
      this.sync();
    }
    move(direction){
      const cards=this.track.children;
      if(cards.length<2)return;
      const step=cards[1].offsetLeft-cards[0].offsetLeft;
      const max=this.track.scrollWidth-this.track.clientWidth;
      let target=this.track.scrollLeft+direction*step;
      if(direction>0&&this.track.scrollLeft>=max-3)target=0;
      if(direction<0&&this.track.scrollLeft<=3)target=max;
      this.track.scrollTo({left:target,behavior:this.motion.matches?'auto':'smooth'});
    }
    sync(){
      clearInterval(this.timer);
      if(!this.toggle)return;
      this.toggle.textContent=this.paused?'▶':'Ⅱ';
      this.toggle.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);
      this.toggle.setAttribute('aria-pressed',String(this.paused));
      if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&!this.motion.matches){
        this.timer=setInterval(()=>this.move(1),Number(this.dataset.delay)||7000);
      }
    }
    disconnectedCallback(){
      clearInterval(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
